define([
	'internal_util/Logger',
	'internal_util/Util',
	'internal_util/Configuration',
	'model/ActivationType',
	'eidclient/TR03124Client',
	'eidclient/TR03124_EP_Client',
	//'eidclient/AusweisApp2',
	'eidclient/OpeneCardApp',
	'service/EidClientEventManager',
	'service/EventListenerRegistry',
	'amdi18n-loader?!service/nls/EidClientManager_strings'
], function (
	Logger,
	Util,
	Configuration,
	ActivationType,
	TR03124Client,
	TR03124_EP_Client,
	//AusweisApp2,
	OpeneCardApp,
	EidClientEventManager,
	EventListenerRegistry,
	Strings
) {
	'use strict';

	return function () {
		var _defaultEidClients = [
				new TR03124Client(),
				new TR03124_EP_Client(),
//				new OpeneCardApp()
				//new AusweisApp2()
			],
			_eidClients = new Object(),
			_eidClientsDetectionState = new Object(),
			_eidClientsDetectionStateTemp = new Object(),
			_detectionStarted = false,
			_detectionRunFinished = false,
			_lastDetectionRun = null,
			_detectionTimeout,
			_startClientsAfterDetection = false,
			_authenticationOptions,
			_skipNextStop = false;


		// private methods

		function log(method, message, data) {
			Logger.log('EidClientManager', method, message, data);
		}

		function callLog(method, message, data, event, callbacks) {
			log(method, message, data);
			EventListenerRegistry.callListeners(event, data, function () {
				Util.callCallbacks(callbacks, data);
			});
		}

		function addEidClients() {
			var authenticationOptions = new Array(),
				eidClient,
				i, j;

			if (!Util.isArray(_authenticationOptions)) {
				authenticationOptions.push(_authenticationOptions);
			} else {
				authenticationOptions = _authenticationOptions;
			}

			_eidClients = new Object();

			for (i = 0; i < _defaultEidClients.length; i++) {
				eidClient = _defaultEidClients[i];

				if (!eidClient.supportsPlatform()) {
					continue;
				}

				for (j = 0; j < authenticationOptions.length; j++) {
					if (authenticationOptions[j].activation() === ActivationType.BROWSER) {
						continue;
					}

					if (eidClient.supportsAuthenticationOption(authenticationOptions[j])) {
						_eidClients[eidClient.id()] = eidClient;
						log('checkAuthenticationOptionsSupport', Strings.eid_client_added, eidClient);
						break;
					}
				}
			}
		}

		function detectedEidClients() {
			var detectedEidClients = new Array(),
				eidClientId = null;

			for (eidClientId in _eidClientsDetectionState) {
				if (_eidClientsDetectionState.hasOwnProperty(eidClientId) 
						){//&& _eidClientsDetectionState[eidClientId] === true) {
					detectedEidClients.push(_eidClients[eidClientId]);
				}
			}

			return detectedEidClients;
		}

		function detectionRunFinished() {
			var eidClients;

			if (!_detectionRunFinished && Util.objectSize(_eidClients) === Util.objectSize(_eidClientsDetectionStateTemp)) {
				_detectionRunFinished = true;

				_eidClientsDetectionState = _eidClientsDetectionStateTemp;
				_lastDetectionRun = new Date();

				eidClients = detectedEidClients();

				callLog('detectionRunFinished', Strings.eid_client_detection_cycle_finished, eidClients, 'EID_CLIENT_DETECTION_CYCLE_FINISHED');

				if (_detectionStarted) {
					_detectionTimeout = setTimeout(detectEidClients, Configuration.get('EID_CLIENT_DETECTION_INTERVAL'));
				}
			}
		}

		function eidClientDetected(eidClientId) {
			return function () {
				callLog('eidClientDetected', Strings.eid_client_detected, _eidClients[eidClientId], 'EID_CLIENT_DETECTED');

				_eidClientsDetectionStateTemp[eidClientId] = true;

				detectionRunFinished();

				if (_startClientsAfterDetection) {
					_eidClients[eidClientId].start();
				}
			};
		}

		function eidClientNotDetected(eidClientId) {
			return function () {
				callLog('eidClientNotDetected', Strings.eid_client_not_detected, _eidClients[eidClientId], 'EID_CLIENT_NOT_DETECTED');

				_eidClientsDetectionStateTemp[eidClientId] = false;

				detectionRunFinished();
			};
		}

		function detectEidClients() {
			var _name = 'detectEidClients',
				eidClientId;

			_eidClientsDetectionStateTemp = new Object();
			_detectionRunFinished = false;

			if (Util.objectSize(_eidClients) !== 0) {
				for (eidClientId in _eidClients) {
					if (_eidClients.hasOwnProperty(eidClientId)) {
						_eidClients[eidClientId].detect(
								eidClientDetected(eidClientId),
								eidClientNotDetected(eidClientId));
					}
				}
			} else {
				callLog(_name, Strings.eid_client_detection_cycle_finished, new Array(), 'EID_CLIENT_DETECTION_CYCLE_FINISHED');
			}
		}


		// public methods

		this.eidClients = function () {
			return _defaultEidClients;
		};

		this.supportedEidClients = function () {
			var eidClients = new Array(),
				i;

			for (i = 0; i < _defaultEidClients.length; i++) {
				if (_defaultEidClients[i].supportsPlatform()) {
					eidClients.push(_defaultEidClients[i]);
				}
			}

			return eidClients;
		};

		this.eidClientById = function (eidClientId) {
			for (var i = 0; i < _defaultEidClients.length; i++) {
				if (_defaultEidClients[i].id() === eidClientId) {
					return _defaultEidClients[i];
				}
			}

			return null;
		};

		this.eidClientAvailable = function (authenticationOption) {
			var eidClients = detectedEidClients(),
				i;

			for (i = 0; i < eidClients.length; i++) {
				if (eidClients[i].supportsAuthenticationOption(authenticationOption)) {
					return true;
				}
			}

			return true; //Kiosk always has a running app
		};

		this.lastDetectionRun = function () {
			return _lastDetectionRun;
		};

		this.startDetection = function (authenticationOptions, startClients) {
			if (_detectionStarted) {
				if (_authenticationOptions === authenticationOptions) {
					_skipNextStop = true;
					return;
				}

				clearTimeout(_detectionTimeout);
			}

			_authenticationOptions = authenticationOptions;

			addEidClients();

			_detectionStarted = true;
			_startClientsAfterDetection = (typeof startClients === 'boolean') ? startClients : true;

			callLog('startDetection', Strings.eid_client_detection_started, _eidClients, 'EID_CLIENT_DETECTION_STARTED', detectEidClients);
		};

		this.stopDetection = function (authenticationOptions, stopClients) {
			if (_detectionStarted && _authenticationOptions === authenticationOptions && !_skipNextStop) {
				clearTimeout(_detectionTimeout);

				_detectionStarted = false;

				if ((typeof stopClients !== 'boolean') || stopClient) {
					this.stopEidClients();
				}

				callLog('stopDetection', Strings.eid_client_detection_stopped, _eidClients, 'EID_CLIENT_DETECTION_STOPPED');
			} else if (_skipNextStop) {
				_skipNextStop = false;
			}
		};

		this.startEidClients = function () {
			var eidClientId = null;

			for (eidClientId in _eidClients) {
				if (_eidClients.hasOwnProperty(eidClientId)) {
					_eidClients[eidClientId].start();
				}
			}
		};

		this.stopEidClients = function () {
			var eidClientId = null;

			for (eidClientId in _eidClients) {
				if (_eidClients.hasOwnProperty(eidClientId)) {
					_eidClients[eidClientId].stop();
				}
			}
		};

		this.activateEidClient = function (authenticationOption, activationURL, callbacks, errorCallbacks) {
			var eidClients = detectedEidClients(),
				i;

			for (i = 0; i < eidClients.length; i++) {
				if (eidClients[i].supportsAuthenticationOption(authenticationOption)) {
					log('activateEidClient', Strings.activating_eid_client, eidClients[i]);

					eidClients[i].activate(
							authenticationOption,
							activationURL,
							function (response) {
								callLog('activationSucceeded', Strings.activation_succeeded, response, 'ACTIVATION_SUCCEEDED', callbacks);
							},
							function (error) {
								callLog('activationFailed', Strings.activation_failed, error, 'ACTIVATION_FAILED', errorCallbacks);
							});

					return;
				}
			}

			Util.callCallbacks(errorCallbacks);
		};
	};
});



//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/service/EidClientManager.js
// module id = 41
// module chunks = 4